import React, { Component } from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  background-color: #fff;

  img {
    width: 100%;
  }
`;

class LicensePage extends Component {
  render() {
    return (
      <Wrapper>
        <img src="/images/index/license.jpg" alt="" />
      </Wrapper>
    );
  }
}

export default LicensePage;
